import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import Slide01 from '@/ui-assets/images/slide01.png';
import Slide02 from '@/ui-assets/images/slide02.png';
import Slide03 from '@/ui-assets/images/slide03.png';
import Slide04 from '@/ui-assets/images/slide04.png';
import Slide05 from '@/ui-assets/images/slide05.png';
import SlideBg from '@/ui-assets/images/slideBg.webp';

import styles from './index.module.scss';

const slides = [
  {
    key: 'slide01',
    image: Slide01,
    title: 'ค้นพบทุกสิ่งที่รอคุณอยู่',
    description: 'กับ Thai PBS One Member<br/>เข้าถึงทุกบริการสาระบันเทิงจาก Thai PBS พิเศษเฉพาะคุณ',
  },
  {
    key: 'slide02',
    image: Slide02,
    title: 'ค้นพบทุกสิ่งที่รอคุณอยู่',
    description: 'กับ Thai PBS One Member<br/>เข้าถึงทุกบริการสาระบันเทิงจาก Thai PBS พิเศษเฉพาะคุณ',
  },
  {
    key: 'slide03',
    image: Slide03,
    title: 'ค้นพบทุกสิ่งที่รอคุณอยู่',
    description: 'กับ Thai PBS One Member<br/>เข้าถึงทุกบริการสาระบันเทิงจาก Thai PBS พิเศษเฉพาะคุณ',
  },
  {
    key: 'slide04',
    image: Slide04,
    title: 'ค้นพบทุกสิ่งที่รอคุณอยู่',
    description: 'กับ Thai PBS One Member<br/>เข้าถึงทุกบริการสาระบันเทิงจาก Thai PBS พิเศษเฉพาะคุณ',
  },
  {
    key: 'slide05',
    image: Slide05,
    title: 'ค้นพบทุกสิ่งที่รอคุณอยู่',
    description: 'กับ Thai PBS One Member<br/>เข้าถึงทุกบริการสาระบันเทิงจาก Thai PBS พิเศษเฉพาะคุณ',
  },
];

const IntroSwiper = () => {
  // Shuffle slides on component mount
  const shuffledSlides = [...slides].sort(() => Math.random() - 0.5);

  return (
    <div className={styles.swiperContainer}>
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{
          clickable: true,
        }}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
      >
        {shuffledSlides.map((slide) => (
          <SwiperSlide key={slide.key}>
            <div className={styles.slide}>
              <img src={slide.image} alt={slide.title} className={styles.image} />
              <div className="textContainer">
                <p className={styles.title}>{slide.title}</p>
                <p className={styles.description} dangerouslySetInnerHTML={{__html: slide.description }} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <img src={SlideBg} className={styles.slideBg} alt="" />
    </div>
  );
};

export default IntroSwiper;
